export default "__VITE_ASSET__BiGKKwyj__"